import {AutosuggestionInputAction} from '@/actions/components/autosuggestion-input';
import {CompetencyComponentService} from '@/imports-files/components/jobScorecardComponent/competency';
import {JOB_SUB_COMPETENCIES_ATTRIBUTES_HASH, JOB_COMPETENCY_COMPETENCY_ATTRIBUTES_HASH, JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH} from '@/constants/pages/clients/jobs/scorecards';
import cloneDeep from 'lodash.clonedeep';

export class CompetencyComponentAction extends AutosuggestionInputAction
{
	constructor(setSubCompetency, subcompetencySelectedValue, setSubcompetencySelectedValue, setFlagForRerender)
	{
		super();		
		this.setSubCompetency = setSubCompetency;
		this.subcompetencySelectedValue = subcompetencySelectedValue;
		this.setSubcompetencySelectedValue = setSubcompetencySelectedValue;
		this.competencyComponentService = new CompetencyComponentService();
		this.setFlagForRerender = setFlagForRerender;
	}

	showCompetency(formik, index)
	{
		let jobSubCompetencyHash = cloneDeep(JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH);
		formik.setFieldValue(`job_competencies_attributes.${index}.job_sub_competencies_attributes`, []);
    this.setSubCompetency(true);
	}

  addSubcompetency(formik, index){
    let jobSubCompetencyHash = cloneDeep(JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH);
    let job_sub_competencies_attributes = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes
    job_sub_competencies_attributes.push(jobSubCompetencyHash)
    this.setFlagForRerender(Math.random()*1000)
  }

  removeSubcompetency(formik, index, subcompetency_index){
    let formik_value_array = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes;
    formik_value_array[subcompetency_index]._destroy = true
    // formik_value_array[subcompetency_index]?.id ? formik_value_array[subcompetency_index]._destroy = true : formik_value_array.splice(subcompetency_index,1);
    formik.setFieldValue(`job_competencies_attributes.${index}.job_sub_competencies_attributes`, formik_value_array);
    this.setFlagForRerender(Math.random()*1000);
    this.setSubcompetencySelectedValue(formik_value_array);
  }

	hideCompetency(formik, index)
	{
		let jobSubCompetencyHash = cloneDeep(JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH);
		let formik_value_array = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes;
		for(let arr_index in formik_value_array)
		{
			formik_value_array[arr_index].id ? formik_value_array[arr_index]._destroy = true : ''; 
		}	
		formik.setFieldValue(`job_competencies_attributes.${index}.job_sub_competencies_attributes`, formik_value_array);
		this.setSubCompetency(false);
		this.setSubcompetencySelectedValue([]);
	}

	removeSelectedValues(event, index, formik, job_competencies_attributes_index, setSubcompetencySelectedValue)
	{
		let formik_value_array = formik.values.job_competencies_attributes[job_competencies_attributes_index].job_sub_competencies_attributes;
		formik_value_array[index]?.id ? formik_value_array[index]._destroy = true : formik_value_array.splice(index,1); 
		formik.setFieldValue(`job_competencies_attributes.${job_competencies_attributes_index}.job_sub_competencies_attributes`, formik_value_array);
		this.setFlagForRerender(Math.random()*1000);
		setSubcompetencySelectedValue(formik_value_array);
	}


	competencyHandleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    {
      if (evt.key === 'Enter')  
      {
          evt.preventDefault();
      }
      else if(evt.target.value.trim() !='')
      {
      	  let value = {label: evt.target.value, value: evt.target.id};
          this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      }
    }

    competencyHandleKeyUp(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    {
    	// if (evt.key === 'Enter')
     //  {
     //     evt.preventDefault();
     //  }
     //  else if(evt.target.value.trim() !='')
     //  {
         evt.preventDefault();
      	 let value = {label: evt.target.value, value: evt.target.id};
      	 this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      // }
    }

	// Function called when pressing the enter key in the input
    handleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params)
    {
    	if (evt.key === 'Enter' && evt.target.value.trim() !='')  
      {
      	  evt.preventDefault();
          let value = {label: evt.target.value, value: evt.target.id};
          this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      }
    }

    handleKeyUp(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params)
    {
    	// if (evt.key === 'Enter' && evt.target.value.trim() !='')
     //  {
     //  	  evt.preventDefault();
        let value = {label: evt.target.value, value: evt.target.id};
        this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      // }
    }

	add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params)
    {
    	let competencyComponentAction = new CompetencyComponentAction();
    	if(params.type == 'client_competency')
    	{
    		if(value.value == '')
	    	{
		    	competencyComponentAction.addCustomClientCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
		    }
		    else
		    {
		    	competencyComponentAction.addSystemClientCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
		    }
    	}
    	else
    	{	
    		if(value.value == '')
	    	{
		    	competencyComponentAction.addCustomJobSubCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
		    }
		    else
		    {
		    	competencyComponentAction.addSystemJobSubCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
		    }
    	}
    	
      setSelectedValues(selectedValues);

    }

    // This function will add the values of the Custom Job sub competencies
    async addCustomJobSubCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params)
    {

      let job_competencies_attributes_array    =   formik.values.job_competencies_attributes[index]?.job_sub_competencies_attributes || [];
      let job_sub_competency_attributes_hash   =  job_competencies_attributes_array[params.subcompetency_index]
  	  job_sub_competency_attributes_hash.name = value.label
      job_sub_competency_attributes_hash.sub_competency_id = null

      formik.setFieldValue(`job_competencies_attributes.${index}.job_sub_competencies_attributes`, job_competencies_attributes_array);
  		params.setFlagForRerender(Math.random()*1000);
	   
    }


    // Add the value in the hash for the system job competency selected from the dropdown
    async addSystemJobSubCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params)
    {
      let job_competencies_attributes_array    =   formik.values.job_competencies_attributes[index]?.job_sub_competencies_attributes || [];
    	let job_sub_competency_attributes_hash   =  job_competencies_attributes_array[params.subcompetency_index]
      job_sub_competency_attributes_hash.name = value.label
      job_sub_competency_attributes_hash.sub_competency_id = value.id
	    formik.setFieldValue(`job_competencies_attributes.${index}.job_sub_competencies_attributes`, job_competencies_attributes_array);
	    params.setFlagForRerender(Math.random()*1000);
	}


	// This function will add the values of the Custom Job sub competencies
    async addCustomClientCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params)
    {
      formik.setFieldValue(`job_competencies_attributes.${index}.name`, value.label);
      formik.setFieldValue(`job_competencies_attributes.${index}.competency_id`, null);
      await setAutosuggestionFieldValue(value.label);
      selectedValues = value;
    }


    // Add the value in the hash for the system job competency selected from the dropdown
    async addSystemClientCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params)
    {
      formik.setFieldValue(`job_competencies_attributes.${index}.name`, value.label);
      formik.setFieldValue(`job_competencies_attributes.${index}.competency_id`, value.id);
    	setAutosuggestionFieldValue(value.label);
    	selectedValues = value;
    }

    submitNotes(params)
    {
    	if(params.formik)
    	{
    		params.formik.setFieldValue(params.name, params.value);
    	}
    	params.setModal({status: false, heading: '', index: params?.index, submitButtonAction:''});
    }

}
